/* Cosmetix — theme.js (v2). No dependencies. */
(() => {
  'use strict';

  const T = window.theme || { routes: {} };
  const R = T.routes || {};
  const $ = (s, c = document) => c.querySelector(s);
  const $$ = (s, c = document) => Array.from(c.querySelectorAll(s));
  const root = document.documentElement;
  const reduceMotion = window.matchMedia('(prefers-reduced-motion: reduce)').matches;

  /* ================= Helpers ================= */
  const esc = (s) => String(s == null ? '' : s).replace(/[&<>"']/g, (c) => ({ '&': '&amp;', '<': '&lt;', '>': '&gt;', '"': '&quot;', "'": '&#39;' }[c]));
  function formatMoney(cents, format) {
    if (typeof cents === 'string') cents = cents.replace('.', '');
    const fmt = format || T.moneyFormat || '${{amount}}';
    const re = /\{\{\s*(\w+)\s*\}\}/;
    const n = (v, p, th = ',', d = '.') => { const [i, f] = (v / 100).toFixed(p).split('.'); return i.replace(/\B(?=(\d{3})+(?!\d))/g, th) + (f ? d + f : ''); };
    const m = fmt.match(re);
    let v;
    switch (m ? m[1] : 'amount') {
      case 'amount_no_decimals': v = n(cents, 0); break;
      case 'amount_with_comma_separator': v = n(cents, 2, '.', ','); break;
      case 'amount_no_decimals_with_comma_separator': v = n(cents, 0, '.', ','); break;
      case 'amount_with_apostrophe_separator': v = n(cents, 2, "'", '.'); break;
      case 'amount_with_space_separator': v = n(cents, 2, ' ', ','); break;
      default: v = n(cents, 2);
    }
    return fmt.replace(re, v).replace(/<[^>]*>/g, '');
  }
  const money = (c) => formatMoney(c);
  const sized = (url, w) => (url ? url + (url.includes('?') ? '&' : '?') + 'width=' + w : '');
  const store = {
    get(k) { try { return window.localStorage.getItem(k); } catch (_) { return null; } },
    set(k, v) { try { window.localStorage.setItem(k, v); } catch (_) { /* storage unavailable */ } },
    sget(k) { try { return window.sessionStorage.getItem(k); } catch (_) { return null; } },
    sset(k, v) { try { window.sessionStorage.setItem(k, v); } catch (_) { /* storage unavailable */ } }
  };
  const debounce = (fn, ms) => { let t; return (...a) => { clearTimeout(t); t = setTimeout(() => fn(...a), ms); }; };
  const icon = {
    plus: '<svg class="icon" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="1.4" aria-hidden="true"><path d="M12 5v14M5 12h14"/></svg>',
    check: '<svg class="icon" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="1.5" aria-hidden="true"><path d="m5 12.5 4.5 4.5L19 7.5"/></svg>'
  };

  let toastTimer;
  function toast(msg) {
    const el = $('[data-toast]');
    if (!el) return;
    el.textContent = msg;
    el.classList.add('is-on');
    clearTimeout(toastTimer);
    toastTimer = setTimeout(() => el.classList.remove('is-on'), 2600);
  }

  /* ================= Header ================= */
  const headerSection = $('.section-header');
  const header = $('[data-header]');
  if (headerSection && header) {
    const sticky = header.classList.contains('header--sticky');
    let lastY = window.scrollY;
    let ticking = false;
    const setTop = () => {
      const visible = sticky && !headerSection.classList.contains('is-hidden');
      root.style.setProperty('--sticky-top', visible ? header.offsetHeight + 'px' : '0px');
      root.style.setProperty('--header-h-live', header.offsetHeight + 'px');
    };
    const onScroll = () => {
      if (ticking) return;
      ticking = true;
      requestAnimationFrame(() => {
        const y = window.scrollY;
        headerSection.classList.toggle('is-scrolled', y > 4);
        if (sticky && !header.classList.contains('has-open-mega') && !root.classList.contains('lock')) {
          const goingDown = y > lastY && y > 240;
          headerSection.classList.toggle('is-hidden', goingDown);
        }
        lastY = y;
        setTop();
        ticking = false;
      });
    };
    window.addEventListener('scroll', onScroll, { passive: true });
    window.addEventListener('resize', debounce(setTop, 150));
    onScroll();

    // Mega menus: hover intent + keyboard
    $$('.nav__item.has-mega', header).forEach((item) => {
      const link = $('.nav__link', item);
      let openT, closeT;
      const open = () => {
        clearTimeout(closeT);
        openT = setTimeout(() => {
          $$('.nav__item.is-open', header).forEach((o) => { if (o !== item) close(o, true); });
          item.classList.add('is-open');
          header.classList.add('has-open-mega');
          link.setAttribute('aria-expanded', 'true');
        }, 90);
      };
      const close = (el = item, now = false) => {
        clearTimeout(openT);
        const run = () => {
          el.classList.remove('is-open');
          $('.nav__link', el).setAttribute('aria-expanded', 'false');
          if (!$('.nav__item.is-open', header)) header.classList.remove('has-open-mega');
        };
        if (now) run(); else closeT = setTimeout(run, 160);
      };
      item.addEventListener('mouseenter', open);
      item.addEventListener('mouseleave', () => close());
      item.addEventListener('focusin', () => { clearTimeout(closeT); item.classList.add('is-open'); header.classList.add('has-open-mega'); link.setAttribute('aria-expanded', 'true'); });
      item.addEventListener('focusout', (e) => { if (!item.contains(e.relatedTarget)) close(item, true); });
    });
  }

  /* ================= Announcement ================= */
  $$('[data-announcements]').forEach((wrap) => {
    const items = $$('[data-announcement]', wrap);
    if (items.length < 2) return;
    let i = 0, timer;
    const show = (n) => { items[i].classList.remove('is-active'); i = (n + items.length) % items.length; items[i].classList.add('is-active'); };
    const start = () => { stop(); if (!reduceMotion) timer = setInterval(() => show(i + 1), (parseInt(wrap.dataset.speed, 10) || 7) * 1000); };
    const stop = () => clearInterval(timer);
    $('[data-announce-prev]', wrap)?.addEventListener('click', () => { show(i - 1); start(); });
    $('[data-announce-next]', wrap)?.addEventListener('click', () => { show(i + 1); start(); });
    wrap.addEventListener('mouseenter', stop);
    wrap.addEventListener('mouseleave', start);
    start();
  });

  /* ================= Drawers ================= */
  let lastFocus = null;
  function openDrawer(name) {
    const d = $(`[data-drawer="${name}"]`);
    if (!d) return;
    closeSearch();
    lastFocus = document.activeElement;
    d.classList.add('is-open');
    d.setAttribute('aria-hidden', 'false');
    root.classList.add('lock');
    const focusEl = $('[data-drawer-close]:not(.drawer__scrim), .icon-btn', d);
    setTimeout(() => focusEl && focusEl.focus({ preventScroll: true }), 60);
  }
  function closeDrawers() {
    const open = $$('[data-drawer].is-open');
    if (!open.length) return;
    open.forEach((d) => { d.classList.remove('is-open'); d.setAttribute('aria-hidden', d.dataset.drawer === 'filters' ? 'false' : 'true'); });
    root.classList.remove('lock');
    if (lastFocus && lastFocus.focus) lastFocus.focus({ preventScroll: true });
  }
  document.addEventListener('click', (e) => {
    const opener = e.target.closest('[data-drawer-open]');
    if (opener) {
      e.preventDefault();
      if (opener.dataset.drawerOpen === 'cart') refreshCart().then(() => openDrawer('cart'));
      else openDrawer(opener.dataset.drawerOpen);
      return;
    }
    if (e.target.closest('[data-drawer-close]')) { e.preventDefault(); closeDrawers(); }
  });
  document.addEventListener('keydown', (e) => {
    if (e.key !== 'Escape') return;
    closeDrawers(); closeSearch(); closeLightbox(); hidePopup(true);
  });
  // simple focus trap for open drawers
  document.addEventListener('keydown', (e) => {
    if (e.key !== 'Tab') return;
    const d = $('[data-drawer].is-open .drawer__panel, [data-drawer].is-open .facets, [data-search-overlay].is-open .search-ov__panel');
    if (!d) return;
    const f = $$('a[href], button:not([disabled]), input:not([type="hidden"]), select, textarea, [tabindex]:not([tabindex="-1"])', d).filter((el) => el.offsetParent !== null);
    if (!f.length) return;
    const first = f[0], last = f[f.length - 1];
    if (e.shiftKey && document.activeElement === first) { e.preventDefault(); last.focus(); }
    else if (!e.shiftKey && document.activeElement === last) { e.preventDefault(); first.focus(); }
  });

  /* ================= Search overlay + predictive ================= */
  const ov = $('[data-search-overlay]');
  const ovInput = ov && $('[data-search-input]', ov);
  const ovResults = ov && $('[data-search-results]', ov);
  const ovDefault = ovResults ? ovResults.innerHTML : '';
  let psController;
  function openSearch() {
    if (!ov) return;
    closeDrawers();
    lastFocus = document.activeElement;
    ov.classList.add('is-open');
    ov.setAttribute('aria-hidden', 'false');
    root.classList.add('lock');
    setTimeout(() => ovInput && ovInput.focus(), 80);
  }
  function closeSearch() {
    if (!ov || !ov.classList.contains('is-open')) return;
    ov.classList.remove('is-open');
    ov.setAttribute('aria-hidden', 'true');
    if (!$('[data-drawer].is-open')) root.classList.remove('lock');
  }
  document.addEventListener('click', (e) => {
    if (e.target.closest('[data-search-open]')) { e.preventDefault(); openSearch(); }
    else if (e.target.closest('[data-search-close]')) { e.preventDefault(); closeSearch(); }
  });
  if (ovInput && R.predictiveSearch) {
    const run = debounce(async () => {
      const q = ovInput.value.trim();
      if (q.length < 2) { ovResults.innerHTML = ovDefault; return; }
      if (psController) psController.abort();
      psController = new AbortController();
      try {
        const url = `${R.predictiveSearch}?q=${encodeURIComponent(q)}&section_id=predictive-search&resources[type]=product,collection,query&resources[limit]=6&resources[options][unavailable_products]=last`;
        const res = await fetch(url, { signal: psController.signal });
        if (!res.ok) throw new Error();
        const html = await res.text();
        const doc = new DOMParser().parseFromString(html, 'text/html');
        const out = doc.querySelector('[data-predictive-results]');
        ovResults.innerHTML = out ? out.innerHTML : ovDefault;
      } catch (err) { if (err.name !== 'AbortError') ovResults.innerHTML = ovDefault; }
    }, 220);
    ovInput.addEventListener('input', run);
  }

  /* ================= Reveal on scroll ================= */
  function initReveal(scope = document) {
    const els = $$('[data-reveal]:not(.is-in)', scope);
    if (!els.length) return;
    if (reduceMotion || !('IntersectionObserver' in window) || !document.body.classList.contains('has-motion')) {
      els.forEach((el) => el.classList.add('is-in'));
      return;
    }
    const io = new IntersectionObserver((entries) => {
      entries.forEach((en) => { if (en.isIntersecting) { en.target.classList.add('is-in'); io.unobserve(en.target); } });
    }, { rootMargin: '0px 0px -6% 0px', threshold: 0.06 });
    els.forEach((el) => io.observe(el));
  }
  initReveal();
  document.addEventListener('shopify:section:load', (e) => { initReveal(e.target); initCarousels(e.target); });

  /* ================= Carousels ================= */
  function initCarousels(scope = document) {
    $$('[data-carousel-section]', scope).forEach((sec) => {
      const track = $('[data-carousel]', sec);
      const prev = $('[data-carousel-prev]', sec);
      const next = $('[data-carousel-next]', sec);
      if (!track || !prev || !next || sec.dataset.carouselReady) return;
      sec.dataset.carouselReady = '1';
      const update = () => {
        const max = track.scrollWidth - track.clientWidth - 2;
        prev.disabled = track.scrollLeft <= 2;
        next.disabled = track.scrollLeft >= max;
        const hide = track.scrollWidth <= track.clientWidth + 4;
        prev.parentElement.hidden = hide;
      };
      const step = () => { const item = track.firstElementChild; return item ? (item.getBoundingClientRect().width + parseFloat(getComputedStyle(track).columnGap || 16)) * Math.max(1, Math.floor(track.clientWidth / item.getBoundingClientRect().width) - 0) : track.clientWidth; };
      prev.addEventListener('click', () => track.scrollBy({ left: -step(), behavior: reduceMotion ? 'auto' : 'smooth' }));
      next.addEventListener('click', () => track.scrollBy({ left: step(), behavior: reduceMotion ? 'auto' : 'smooth' }));
      track.addEventListener('scroll', debounce(update, 60), { passive: true });
      window.addEventListener('resize', debounce(update, 150));
      update();
    });
  }
  initCarousels();

  /* ================= Cart ================= */
  const cartUrl = (path = '') => (R.cart || '/cart') + path;
  async function getCart() { const r = await fetch(cartUrl('.js'), { headers: { Accept: 'application/json' } }); return r.json(); }

  function renderShip(cart) {
    const bar = $('[data-ship]');
    const threshold = Number(T.freeShippingThreshold) || 0;
    if (!bar || threshold <= 0) return;
    const remaining = threshold - cart.total_price;
    $('[data-ship-fill]', bar).style.width = Math.min(100, (cart.total_price / threshold) * 100) + '%';
    $('[data-ship-text]', bar).innerHTML = remaining > 0
      ? `You're <strong>${esc(money(remaining))}</strong> away from free shipping`
      : `<strong>Free shipping</strong> unlocked`;
    bar.classList.toggle('is-done', remaining <= 0);
    bar.hidden = cart.item_count === 0;
  }

  function renderCart(cart, { bump = false } = {}) {
    $$('[data-cart-count]').forEach((el) => {
      el.textContent = cart.item_count;
      if (el.hasAttribute('data-hide-empty')) el.hidden = cart.item_count === 0;
      if (bump) { el.classList.remove('is-bump'); void el.offsetWidth; el.classList.add('is-bump'); }
    });
    $$('[data-cart-count-label]').forEach((el) => { el.textContent = cart.item_count; });
    $$('.header__cart').forEach((el) => el.setAttribute('aria-label', `Bag, ${cart.item_count} items`));
    $$('[data-cart-subtotal]').forEach((el) => { el.textContent = money(cart.total_price); });
    const foot = $('[data-cart-foot]');
    if (foot) foot.hidden = cart.item_count === 0;
    renderShip(cart);

    const wrap = $('[data-cart-items]');
    if (!wrap) return;
    if (!cart.item_count) {
      wrap.innerHTML = `<div class="cart-empty"><p class="cart-empty__title">Your bag is empty</p><p class="cart-empty__text">Authentic favorites, for less — start with what's new.</p><a class="btn" href="${esc(R.allProducts || '/collections/all')}">Shop all</a></div>`;
      const up = $('[data-upsell]'); if (up) up.hidden = true;
      return;
    }
    wrap.innerHTML = cart.items.map((it, idx) => {
      const variant = it.variant_title && !it.product_has_only_default_variant ? `<p class="line__variant">${esc(it.variant_title)}</p>` : '';
      const was = it.original_line_price > it.final_line_price ? `<s>${esc(money(it.original_line_price))}</s>` : '';
      return `
      <div class="line" data-line="${idx + 1}" style="--i:${idx}">
        <a class="line__img" href="${esc(it.url)}">${it.image ? `<img src="${esc(sized(it.image, 240))}" alt="${esc(it.product_title)}" width="84" height="105" loading="lazy">` : ''}</a>
        <div>
          <div class="line__top">
            <div>
              ${it.vendor ? `<p class="line__vendor">${esc(it.vendor)}</p>` : ''}
              <a class="line__title" href="${esc(it.url)}">${esc(it.product_title)}</a>
              ${variant}
            </div>
            <p class="line__price">${was}${esc(money(it.final_line_price))}</p>
          </div>
          <div class="line__bottom">
            <div class="qty qty--sm">
              <button type="button" data-line-qty="${it.quantity - 1}" aria-label="Decrease quantity">−</button>
              <span aria-label="Quantity">${it.quantity}</span>
              <button type="button" data-line-qty="${it.quantity + 1}" aria-label="Increase quantity">+</button>
            </div>
            <button type="button" class="line__remove" data-line-qty="0">Remove</button>
          </div>
        </div>
      </div>`;
    }).join('');
    loadUpsell(cart);
  }

  async function refreshCart() { try { renderCart(await getCart()); } catch (_) { /* keep server state */ } }

  async function changeLine(line, quantity, el) {
    el && el.classList.add('is-busy');
    try {
      const r = await fetch((R.cartChange || '/cart/change') + '.js', {
        method: 'POST', headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
        body: JSON.stringify({ line, quantity })
      });
      const cart = await r.json();
      if (!r.ok) throw new Error(cart.description || 'Could not update your bag');
      renderCart(cart);
    } catch (err) { el && el.classList.remove('is-busy'); toast(err.message); }
  }
  document.addEventListener('click', (e) => {
    const b = e.target.closest('[data-line-qty]');
    if (!b) return;
    const el = b.closest('[data-line]');
    if (el) changeLine(Number(el.dataset.line), Math.max(0, Number(b.dataset.lineQty)), el);
  });

  async function addToCart(body) {
    const isForm = body instanceof FormData;
    const r = await fetch((R.cartAdd || '/cart/add') + '.js', {
      method: 'POST',
      headers: isForm ? { Accept: 'application/json', 'X-Requested-With': 'XMLHttpRequest' } : { 'Content-Type': 'application/json', Accept: 'application/json' },
      body: isForm ? body : JSON.stringify(body)
    });
    const data = await r.json();
    if (!r.ok || data.status) throw new Error(data.description || data.message || 'Could not add to bag');
    return data;
  }
  async function afterAdd() {
    const cart = await getCart();
    renderCart(cart, { bump: true });
    if (T.cartType === 'drawer') openDrawer('cart'); else toast('Added to your bag');
  }

  document.addEventListener('submit', async (e) => {
    const form = e.target.closest('form[data-product-form]');
    if (!form || !window.fetch) return;
    if (T.cartType !== 'drawer' && !form.classList.contains('card__quick') && form.id !== 'QuickForm') return;
    e.preventDefault();
    const btns = $$(`[type="submit"]`, form).concat(form.id ? $$(`[type="submit"][form="${form.id}"]`) : []);
    const err = $('[data-form-error]', form);
    btns.forEach((b) => { b.classList.add('is-loading'); b.disabled = true; });
    try {
      await addToCart(new FormData(form));
      if (err) err.hidden = true;
      if (drawerIsOpen('quick')) closeDrawers();
      await afterAdd();
    } catch (x) {
      if (err) { err.textContent = x.message; err.hidden = false; } else toast(x.message);
    } finally {
      btns.forEach((b) => { b.classList.remove('is-loading'); b.disabled = false; });
    }
  });
  const drawerIsOpen = (n) => !!$(`[data-drawer="${n}"].is-open`);

  // cart note (saved quietly)
  const note = $('[data-cart-note]');
  if (note) note.addEventListener('input', debounce(() => {
    fetch(cartUrl('/update.js'), { method: 'POST', headers: { 'Content-Type': 'application/json' }, body: JSON.stringify({ note: note.value }) }).catch(() => {});
  }, 500));

  // upsell ("Pairs well with")
  let upsellFor = null;
  async function loadUpsell(cart) {
    const box = $('[data-upsell]');
    if (!box || !T.cartUpsell || !R.recommendations || !cart.items.length) return;
    const pid = cart.items[0].product_id;
    const inCart = new Set(cart.items.map((i) => i.product_id));
    if (upsellFor === pid && box.dataset.filled) { box.hidden = !$('[data-upsell-list]', box).children.length; return; }
    upsellFor = pid;
    try {
      let recs = [];
      for (const intent of ['complementary', 'related']) {
        const r = await fetch(`${R.recommendations}.json?product_id=${pid}&limit=6&intent=${intent}`);
        if (r.ok) { const d = await r.json(); recs = (d.products || []).filter((p) => !inCart.has(p.id) && p.available); }
        if (recs.length) break;
      }
      const list = $('[data-upsell-list]', box);
      list.innerHTML = recs.slice(0, 4).map((p) => {
        const v = p.variants.find((x) => x.available) || p.variants[0];
        const multi = p.variants.length > 1;
        return `<div class="up">
          <a class="up__img" href="${esc(p.url)}">${p.featured_image ? `<img src="${esc(sized(p.featured_image, 160))}" alt="" loading="lazy">` : ''}</a>
          <div><a class="up__title" href="${esc(p.url)}">${esc(p.title)}</a><p class="up__price">${esc(money(p.price))}</p></div>
          ${multi ? `<button type="button" class="up__add" data-quick-add="${esc(p.url)}" aria-label="Choose options">${icon.plus}</button>` : `<button type="button" class="up__add" data-upsell-add="${v.id}" aria-label="Add ${esc(p.title)}">${icon.plus}</button>`}
        </div>`;
      }).join('');
      box.dataset.filled = '1';
      box.hidden = !recs.length;
    } catch (_) { box.hidden = true; }
  }
  document.addEventListener('click', async (e) => {
    const b = e.target.closest('[data-upsell-add]');
    if (!b) return;
    b.disabled = true;
    try { await addToCart({ items: [{ id: Number(b.dataset.upsellAdd), quantity: 1 }] }); upsellFor = null; renderCart(await getCart(), { bump: true }); }
    catch (x) { toast(x.message); b.disabled = false; }
  });

  /* ================= Quick add ================= */
  document.addEventListener('click', async (e) => {
    const b = e.target.closest('[data-quick-add]');
    if (!b) return;
    e.preventDefault();
    const body = $('[data-quick-body]');
    if (!body) { window.location.href = b.dataset.quickAdd; return; }
    body.innerHTML = '<div class="qa__loading"><span class="spinner"></span></div>';
    openDrawer('quick');
    try {
      const url = b.dataset.quickAdd.split('?')[0];
      const r = await fetch(url + '.js');
      if (!r.ok) throw new Error();
      renderQuick(body, await r.json(), url);
    } catch (_) { window.location.href = b.dataset.quickAdd; }
  });

  function renderQuick(body, p, url) {
    let v = p.variants.find((x) => x.available) || p.variants[0];
    const selected = v.options.slice();
    const opts = (p.options || []).map((o, oi) => {
      const name = typeof o === 'string' ? o : o.name;
      const values = typeof o === 'string' ? [...new Set(p.variants.map((x) => x.options[oi]))] : o.values;
      return `<fieldset class="picker__group" data-qa-opt="${oi}">
        <legend class="picker__legend"><span class="label">${esc(name)}</span><span class="picker__value" data-qa-label>${esc(selected[oi])}</span></legend>
        <div class="picker__values">${values.map((val, vi) => `<input type="radio" class="visually-hidden" id="qa-${oi}-${vi}" name="qa-${oi}" value="${esc(val)}" ${val === selected[oi] ? 'checked' : ''}><label class="pill" for="qa-${oi}-${vi}">${esc(val)}</label>`).join('')}</div>
      </fieldset>`;
    }).join('');
    const img = (v.featured_image && v.featured_image.src) || p.featured_image;
    body.innerHTML = `<div class="qa__grid">
      <div class="qa__media"><img src="${esc(sized(img, 900))}" alt="${esc(p.title)}" data-qa-img></div>
      <div class="qa__info">
        <div>${p.vendor ? `<p class="card__vendor">${esc(p.vendor)}</p>` : ''}<p class="qa__title">${esc(p.title)}</p></div>
        <div class="price" data-qa-price></div>
        ${p.has_only_default_variant ? '' : `<div class="picker">${opts}</div>`}
        <form data-product-form class="buy__form" id="QuickForm" action="${esc(R.cartAdd || '/cart/add')}" method="post">
          <input type="hidden" name="id" value="${v.id}" data-qa-id>
          <input type="hidden" name="quantity" value="1">
          <button type="submit" class="btn btn--lg btn--block" data-qa-btn>Add to bag</button>
          <p class="form-error" data-form-error hidden></p>
        </form>
        <a href="${esc(url)}" class="text-link qa__more">View full details</a>
      </div></div>`;
    const priceEl = $('[data-qa-price]', body);
    const idEl = $('[data-qa-id]', body);
    const btn = $('[data-qa-btn]', body);
    const imgEl = $('[data-qa-img]', body);
    const mark = () => {
      $$('[data-qa-opt]', body).forEach((fs) => {
        const oi = Number(fs.dataset.qaOpt);
        $$('input', fs).forEach((inp) => {
          const test = selected.slice(); test[oi] = inp.value;
          const m = p.variants.find((x) => x.options.every((o, i) => o === test[i]));
          inp.nextElementSibling.classList.toggle('is-unavailable', !m || !m.available);
        });
      });
    };
    const update = () => {
      v = p.variants.find((x) => x.options.every((o, i) => o === selected[i]));
      if (!v) { btn.disabled = true; btn.textContent = 'Unavailable'; return; }
      idEl.value = v.id;
      const sale = v.compare_at_price && v.compare_at_price > v.price;
      priceEl.className = 'price' + (sale ? ' price--sale' : '');
      priceEl.innerHTML = `<span class="price__now">${esc(money(v.price))}</span>${sale ? `<s class="price__was">${esc(money(v.compare_at_price))}</s>` : ''}`;
      btn.disabled = !v.available;
      btn.textContent = v.available ? 'Add to bag' : 'Sold out';
      if (v.featured_image && v.featured_image.src) imgEl.src = sized(v.featured_image.src, 900);
      mark();
    };
    body.addEventListener('change', (e) => {
      const fs = e.target.closest('[data-qa-opt]');
      if (!fs) return;
      selected[Number(fs.dataset.qaOpt)] = e.target.value;
      $('[data-qa-label]', fs).textContent = e.target.value;
      update();
    });
    update();
  }

  /* ================= Quantity steppers ================= */
  document.addEventListener('click', (e) => {
    const b = e.target.closest('[data-qty-btn]');
    if (!b) return;
    const input = b.parentElement.querySelector('input');
    if (!input) return;
    const min = parseInt(input.min || '1', 10);
    input.value = Math.max(min, (parseInt(input.value, 10) || min) + (b.dataset.qtyBtn === 'plus' ? 1 : -1));
    input.dispatchEvent(new Event('change', { bubbles: true }));
  });
  $$('[data-cart-page-qty]').forEach((input) => {
    input.addEventListener('change', debounce(() => { const u = $('[data-cart-update]'); if (u) u.click(); }, 700));
  });

  /* ================= Product page ================= */
  let lightbox;
  function closeLightbox() { if (lightbox && !lightbox.hidden) { lightbox.hidden = true; if (!$('[data-drawer].is-open')) root.classList.remove('lock'); } }

  $$('[data-product]').forEach((section) => {
    let variants = [];
    try { variants = JSON.parse($('[data-product-json]', section).textContent); } catch (_) { return; }

    // gallery
    const track = $('[data-gallery-track]', section);
    const slides = track ? $$('.stage__slide', track) : [];
    const thumbs = $$('[data-thumb]', section);
    const dots = $$('.dot', section);
    let current = 0;
    const setActive = (i) => {
      current = i;
      thumbs.forEach((t, n) => t.classList.toggle('is-active', n === i));
      dots.forEach((d, n) => d.classList.toggle('is-active', n === i));
    };
    const goTo = (i, smooth = true) => {
      if (!track || !slides[i]) return;
      track.scrollTo({ left: slides[i].offsetLeft - track.offsetLeft, behavior: smooth && !reduceMotion ? 'smooth' : 'auto' });
      setActive(i);
    };
    const goToMedia = (id) => { const i = slides.findIndex((s) => s.dataset.mediaId === String(id)); if (i > -1) goTo(i); };
    thumbs.forEach((t, i) => t.addEventListener('click', () => goTo(i)));
    $('[data-stage-prev]', section)?.addEventListener('click', () => goTo(Math.max(0, current - 1)));
    $('[data-stage-next]', section)?.addEventListener('click', () => goTo(Math.min(slides.length - 1, current + 1)));
    if (track) track.addEventListener('scroll', debounce(() => setActive(Math.round(track.scrollLeft / track.clientWidth)), 60), { passive: true });

    // lightbox
    lightbox = $('[data-lightbox]', section);
    const lbImg = lightbox && $('[data-lightbox-img]', lightbox);
    section.addEventListener('click', (e) => {
      const z = e.target.closest('[data-zoom]');
      if (z && lightbox) { lbImg.src = z.dataset.zoom; lbImg.alt = ''; lightbox.hidden = false; root.classList.add('lock'); }
    });
    lightbox?.addEventListener('click', closeLightbox);

    // sticky buy bar
    const sticky = $('[data-sticky-buy]', section);
    const buy = $('[data-buy]', section);
    if (sticky && buy && 'IntersectionObserver' in window) {
      let buyVisible = true, footerVisible = false;
      const sync = () => { const on = !buyVisible && !footerVisible && window.scrollY > buy.offsetTop; sticky.classList.toggle('is-on', on); sticky.setAttribute('aria-hidden', on ? 'false' : 'true'); };
      new IntersectionObserver(([en]) => { buyVisible = en.isIntersecting; sync(); }).observe(buy);
      const footer = $('.footer');
      if (footer) new IntersectionObserver(([en]) => { footerVisible = en.isIntersecting; sync(); }).observe(footer);
    }

    // variant picker
    const picker = $('[data-variant-picker]', section);
    if (!picker) return;
    const groups = $$('.picker__group', picker);
    const readSel = () => groups.map((g) => { const c = $('input:checked', g); return c ? c.value : null; });
    const mark = (sel) => {
      groups.forEach((g, pos) => {
        $$('input', g).forEach((inp) => {
          const test = sel.slice(); test[pos] = inp.value;
          const m = variants.find((v) => v.options.every((o, i) => o === test[i]));
          inp.nextElementSibling?.classList.toggle('is-unavailable', !m || !m.available);
        });
      });
    };
    const update = () => {
      const sel = readSel();
      groups.forEach((g, i) => { const l = $('[data-option-label]', g); if (l) l.textContent = sel[i]; });
      mark(sel);
      const v = variants.find((x) => x.options.every((o, i) => o === sel[i]));
      const addBtns = $$('[data-add-btn]', section);
      if (!v) { addBtns.forEach((b) => { b.disabled = true; $('[data-add-text]', b).textContent = 'Unavailable'; }); return; }
      const idInput = $('[data-variant-id]', section);
      if (idInput) idInput.value = v.id;
      $$('[data-price]', section).forEach((el) => { el.textContent = money(v.price); });
      const sale = v.compare_at_price && v.compare_at_price > v.price;
      $$('[data-compare]', section).forEach((el) => { el.hidden = !sale; el.innerHTML = sale ? `<span class="visually-hidden">Regular price </span>${esc(money(v.compare_at_price))}` : ''; el.closest('[data-price-wrap]')?.classList.toggle('price--sale', !!sale); });
      $$('[data-saving]', section).forEach((el) => { el.hidden = !sale; el.textContent = sale ? `Save ${money(v.compare_at_price - v.price)}` : ''; });
      $$('[data-add-price]', section).forEach((el) => { el.textContent = v.available ? `· ${money(v.price)}` : ''; });
      $$('[data-sticky-variant]', section).forEach((el) => { el.textContent = v.title === 'Default Title' ? '' : v.title; });
      const sku = $('[data-sku]', section); if (sku) sku.textContent = v.sku || '';
      const low = $('[data-low-stock]', section); if (low) low.hidden = true;
      addBtns.forEach((b) => { b.disabled = !v.available; $('[data-add-text]', b).textContent = v.available ? 'Add to bag' : 'Sold out'; });
      if (v.featured_media) goToMedia(v.featured_media.id);
      const url = new URL(window.location.href);
      url.searchParams.set('variant', v.id);
      window.history.replaceState({}, '', url.toString());
    };
    picker.addEventListener('change', update);
    mark(readSel());
  });

  /* ================= Recommendations (product page) ================= */
  $$('[data-recs-url]').forEach(async (el) => {
    if (el.children.length) return;
    try {
      const r = await fetch(el.dataset.recsUrl);
      const doc = new DOMParser().parseFromString(await r.text(), 'text/html');
      const fresh = doc.querySelector('[data-recs-url]');
      if (fresh && fresh.innerHTML.trim()) { el.innerHTML = fresh.innerHTML; initReveal(el); initCarousels(el.closest('[data-carousel-section]')?.parentElement || document); }
    } catch (_) { /* optional */ }
  });

  /* ================= Collection: filters, sort, load more ================= */
  const facetForm = $('[data-facet-form]');
  const submitFacets = () => {
    if (!facetForm) return;
    const params = new URLSearchParams();
    for (const [k, v] of new FormData(facetForm)) if (v !== '') params.append(k, v);
    document.body.style.cursor = 'progress';
    window.location.search = params.toString();
  };
  if (facetForm) {
    const run = debounce(submitFacets, 450);
    facetForm.addEventListener('change', (e) => { if (e.target.type === 'number') run(); else submitFacets(); });
    facetForm.addEventListener('submit', (e) => { e.preventDefault(); submitFacets(); });
  }
  $$('[data-sort]').forEach((s) => s.addEventListener('change', () => {
    const hidden = facetForm && $('[name="sort_by"]', facetForm);
    if (hidden) { hidden.value = s.value; submitFacets(); return; }
    const p = new URLSearchParams(window.location.search); p.set('sort_by', s.value); p.delete('page');
    window.location.search = p.toString();
  }));
  document.addEventListener('click', async (e) => {
    const more = e.target.closest('[data-load-more]');
    if (!more) return;
    e.preventDefault();
    more.classList.add('is-loading');
    try {
      const r = await fetch(more.href);
      const doc = new DOMParser().parseFromString(await r.text(), 'text/html');
      const grid = $('[data-product-grid]');
      const newItems = $$('[data-product-grid] > li', doc);
      newItems.forEach((li, i) => { li.style.setProperty('--i', i % 4); grid.appendChild(li); });
      initReveal(grid);
      const wrapNew = $('[data-load-more-wrap]', doc);
      const wrap = $('[data-load-more-wrap]');
      if (wrapNew && wrap) wrap.innerHTML = wrapNew.innerHTML;
    } catch (_) { window.location.href = more.href; }
  });

  /* ================= Email pop-up ================= */
  const pop = $('[data-popup]');
  const POP_KEY = 'cx_popup_closed';
  function hidePopup(remember) {
    if (!pop || pop.hidden) return;
    pop.classList.remove('is-in');
    setTimeout(() => { pop.hidden = true; }, 520);
    if (remember) store.set(POP_KEY, String(Date.now()));
  }
  if (pop) {
    const days = (T.popup && T.popup.days) || 30;
    const closedAt = Number(store.get(POP_KEY) || 0);
    const recentlyClosed = closedAt && (Date.now() - closedAt) < days * 864e5;
    const posted = /customer_posted=true/.test(window.location.search) && window.location.hash === '#PopupForm';
    const show = () => { if (!pop.hidden) return; pop.hidden = false; requestAnimationFrame(() => requestAnimationFrame(() => pop.classList.add('is-in'))); store.sset('cx_popup_seen', '1'); };
    $('[data-popup-close]', pop)?.addEventListener('click', () => hidePopup(true));
    if (posted) { show(); store.set(POP_KEY, String(Date.now())); setTimeout(() => hidePopup(false), 5000); }
    else if (!recentlyClosed && !store.sget('cx_popup_seen')) {
      // Only after real engagement: time on site AND some scrolling
      let timeOk = false, scrollOk = false;
      const maybe = () => { if (timeOk && scrollOk && !$('[data-drawer].is-open') && !(ov && ov.classList.contains('is-open'))) show(); };
      setTimeout(() => { timeOk = true; maybe(); }, ((T.popup && T.popup.delay) || 35) * 1000);
      const onS = () => { if (window.scrollY > window.innerHeight * 0.6) { scrollOk = true; window.removeEventListener('scroll', onS); maybe(); } };
      window.addEventListener('scroll', onS, { passive: true });
    }
  }

  /* Pre-render the bag so it opens instantly */
  if (T.cartType === 'drawer' && $('[data-cart-items]')) refreshCart();
})();
